import * as React from "react";
const SvgFiRrGrinTongueSquint = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grin-tongue-squint_svg__a)">
      <path
        fill="#062147"
        d="M16 14H8a1 1 0 0 0 0 2h1v.6c.133 4.495 5.869 4.49 6 0V16h1a1 1 0 0 0 0-2m-3 2.6c-.062 1.839-1.938 1.837-2 0V16h2zm4.555-8.768L15.8 9l1.752 1.168a1 1 0 1 1-1.11 1.664l-3-2a1.007 1.007 0 0 1 0-1.664l3-2a1 1 0 0 1 1.11 1.664zM7 12a1 1 0 0 1-.556-1.832L8.2 9 6.445 7.832a1 1 0 1 1 1.11-1.664l3 2a1.007 1.007 0 0 1 0 1.664l-3 2A1 1 0 0 1 7 12m5-12A12.013 12.013 0 0 0 0 12c.6 15.9 23.4 15.893 24 0A12.013 12.013 0 0 0 12 0m0 22A10.01 10.01 0 0 1 2 12c.5-13.248 19.5-13.244 20 0a10.01 10.01 0 0 1-10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grin-tongue-squint_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrinTongueSquint;
